"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentReminder = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentReminder = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
    due_date: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
});
//# sourceMappingURL=payment-reminder.js.map